import {FC, ReactElement} from 'react'
import {useSelector} from 'react-redux'

import {TooltipWrapper, TooltipBody} from '../TooltipWrapper'
import {ValidUserTypes} from 'interfaces'
import {selectUser} from 'features/User'
import {RBACEyeIcon} from '../SvgIcon'

interface Props {
  isTrue: boolean
  children: ReactElement
}

interface CanProps {
  type: string // we need to change this to array string
  children: ReactElement
  showEyeIcon?: boolean
  reqRoles?: string[]
  fallbackComponent?: JSX.Element
}

export const RenderIf: FC<Props> = ({children, isTrue}) => {
  return isTrue ? children : null
}

export const CanIRender: FC<CanProps> = ({
  children,
  reqRoles = [ValidUserTypes.Administrator],
  showEyeIcon = false,
}) => {
  // Fetch roles and permissions for the user.
  const {role: currRole} = useSelector(selectUser)

  /**
   * Fallback can also be used for loading state if required.
   */

  // Check if user has required roles and permissions
  const hasReqRole = reqRoles.includes(currRole)

  /**
   * Include this code if you want to check for permissions as well.
   * @type - Array of permissions for the user with which you want to check.
   * @permissions - Array of permissions fetched from the user(backend)
   * 
        const hasReqPermission = reqPermissions.every(perm =>
            permissions.includes(perm),
        )
   */

  if (hasReqRole) {
    return <>{children}</>
  }

  return (
    <RenderIf isTrue={showEyeIcon}>
      <>
        <TooltipWrapper
          id="can-i-render-tooltip"
          className="ml-1 z-50"
          noArrow
          place="right"
          noPadding
        >
          <TooltipBody>You have read-only permissions</TooltipBody>
        </TooltipWrapper>
        <span data-tooltip-id="can-i-render-tooltip">
          <RBACEyeIcon />
        </span>
      </>
    </RenderIf>
  )
}
